import React from 'react';
import { createMedia } from '@artsy/fresnel';
import { Container } from 'semantic-ui-react';
import ModalManager from '../common/modals/ModalManager';
import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import LoadingComponent from './LoadingComponent';
import { breakpoints } from '../config/mediaBreakpoints';
import { leftMenuItems, rightMenuItems } from '../config/menuItems';
import ResponsiveNavBar from '../../features/nav/ResponsiveNavBar';
import Footer from '../../features/footer/Footer';
import Routes from './Routes';
import { Fragment } from 'react';
import { Route } from 'react-router-dom';
import SiteMap from '../../features/SiteMap';

const AppMedia = createMedia({
  breakpoints,
});
const mediaStyles = AppMedia.createMediaStyle();
const { Media, MediaContextProvider } = AppMedia;

function App() {
  //  const { key } = useLocation();
  const { initialized } = useSelector((state) => state.async);

  if (!initialized) return <LoadingComponent content='Loading...' />;

  return (
    <Fragment>
      <Route path='/sitemap' component={SiteMap} />
      <style>{mediaStyles}</style>
      <ModalManager />
      <ToastContainer position='bottom-right' hideProgressBar />
      <MediaContextProvider>
        <ResponsiveNavBar
          Media={Media}
          leftMenuItems={leftMenuItems}
          rightMenuItems={rightMenuItems}
        >
          <Container className='main'>
            <Routes />
          </Container>
          <Footer />
        </ResponsiveNavBar>
      </MediaContextProvider>
    </Fragment>
  );
}

export default App;
